import { render, staticRenderFns } from "./stockSetting.vue?vue&type=template&id=accf1c40&"
import script from "./stockSetting.vue?vue&type=script&lang=js&"
export * from "./stockSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "stockSetting.vue"
export default component.exports